export default __webpack_public_path__ + "static/media/textFileIcon.9e84ebed.svg";